export interface Capacity {
    date: string;
    slot?: CapacityMetrics;
    hour?: CapacityMetrics;
    transport: Transport[];
}

export interface CapacityMetrics {
    total: number;
    booked: number;
    remaining: number;
    healthInd: CapacityHealthIndEnum;
}

export interface Transport {
    id: number;
    name: string;
}

export enum CapacityHealthIndEnum {
    FULL = 'full',
    HALF = 'half',
    LOW = 'low'
}

export enum CapacityHealthDisplayTextEnum {
    FULL = '100% Booked',
    HALF = '> 50% Booked',
    LOW = '< 50% Booked'
}

export interface ICapacityResponse {
    status: {
        code: string,
        messages: string[]
    },
    capacity: Capacity[]
}

export interface ICapacityUpdateResponse {
    status: {
        code: string,
        messages: string[]
    },
    capacity: Capacity
}
